
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {Scenario} from "@/scenarios/Scenarios";

    @Component
    export default class ScenarioInput extends Vue {
        @Prop() private scenario!: Scenario;
        rps = 0;
        rpsHandler?: number;

        invoke(number: number) {
            for (let i = 0; i < number; i++) {
                this.scenario.invoke();
            }
        }

        @Watch('rps')
        onPropertyChanged(rps: number) {
            window.clearInterval(this.rpsHandler);
            const threshold = 20;
            if (rps > threshold) {
                this.rpsHandler = window.setInterval(() => {
                    for (let i = 0; i < Math.round(rps / threshold); i++) {
                        this.scenario.invoke();
                    }
                }, Math.round(1000 / threshold));
            } else if (rps > 0) {
                this.rpsHandler = window.setInterval(() => {
                    this.scenario.invoke();
                }, Math.floor(1000 / rps));
            }
        }
    }
